import { render, staticRenderFns } from "./block_contactoAdicional_twitter.vue?vue&type=template&id=99c3c3c8"
import script from "./block_contactoAdicional_twitter.vue?vue&type=script&lang=js"
export * from "./block_contactoAdicional_twitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports